import css from 'styled-jsx/css';
import { colors } from '../../../config/styles/index';
import { ERROR_X_ICON } from '../../../static/images/dataUri';

const formInputStyles = css`
  .textfield-wrapper {
    width: 100%;
    margin-bottom: 4px;
    min-height: 70px;
    position: relative;

    &:first-child {
      margin-top: 12px;
    }

    .error-input {
      border-bottom: 1px solid ${colors.red.shade3};
    }
    .reveal-btn {
      position: absolute;
      top: auto;
      right: 13px;
      bottom: 24px;
      @mixin tabletToDesktop {
        top: 10px;
        bottom: auto;
      }
    }
    .error-icon {
      background-image: url(${ERROR_X_ICON});
      height: 15px;
      width: 15px;
      background-repeat: no-repeat;
    }
    .csicon-eye-close {
      font-size: 20px;
      color: ${colors.gray.shade5};
    }

    .form-icon {
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      display: inline-block;
    }
    label {
      font-size: 12px;
      color: ${colors.black.shade1};
      @mixin tabletToDesktop {
        display: none;
      }
    }
    input {
      font-size: 16px;
      width: 100%;
      padding: 10px 0;
      border: 0;
      padding-right: 50px;
      color: #333;
      border-bottom: 1px solid ${colors.gray.shade5};
      display: flex;
      flex-direction: row;
      outline: none;

      &.placeholder {
        /* stylelint-disable declaration-no-important */
        @mixin placeholder {
          color: ${colors.gray.shade5} !important;
        }
      }

      @mixin placeholder {
        color: ${colors.gray.shade5};
        font-size: 16px;
      }

      @mixin tabletToDesktop {
        @mixin placeholder {
          color: ${colors.black.shade1};
        }
      }

      &:focus {
        border-bottom-color: ${colors.black.shade1};
      }
    }
    .error {
      color: ${colors.red.shade3};
      font-size: 12px;
      padding: 0;
      margin: 0;
      padding-top: 2px;
    }
  }
`;

export default formInputStyles;
